import { useEffect, useState } from "react";
import { instance } from "../../../../../../axios";

// Shipment data must not replace the center selected in the left navigation.
export default function useShipmentCenter(centerId, includeDetails = false) {
  const [result, setResult] = useState(null);
  const url = centerId
    ? `/center/${centerId}${includeDetails ? "/data" : ""}`
    : null;

  useEffect(() => {
    if (!url) return;
    let active = true;

    instance({ method: "GET", url })
      .then(({ data }) => {
        if (active) setResult({ url, data });
      })
      .catch((error) => {
        if (active) {
          setResult(null);
          console.error("Error loading shipment center:", error);
        }
      });

    return () => {
      active = false;
    };
  }, [url]);

  return result?.url === url ? result.data : null;
}
